import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { grid } from './styles.js';
var GridContext =
/*#__PURE__*/
React.createContext({});

var Grid = function Grid(props) {
  var _React$useContext = React.useContext(GridContext),
      offsets = _React$useContext.offsets;

  return (
    /*#__PURE__*/
    React.createElement(grid, _extends({
      "data-test": "elemental-Grid",
      offsets: offsets
    }, props))
  );
};

export { Grid, GridContext };